import { render, staticRenderFns } from "./KeywordDetails.vue?vue&type=template&id=0ba28e46&"
import script from "./KeywordDetails.vue?vue&type=script&lang=js&"
export * from "./KeywordDetails.vue?vue&type=script&lang=js&"
import style0 from "./KeywordDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports